<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'accrual-from-oracle',
};
</script>
